export default __webpack_public_path__ + "static/media/mobilebg.daf54a04.jpg";